<template>
  <el-dialog title="门诊收费" width="64rem" top="4vh" :visible="visible" :close-on-click-modal="false" @open="init" @close="close">
    <patient-selector v-model="patient" :type.sync="opType" @ok="query" @cancel="init" ref="refPatient" hide-edit hide-create />
    <el-checkbox-group v-model="regs" size="mini" style="text-align:left;padding: 1rem 0 1rem 0;" @change="checkboxChange">
      <el-checkbox v-for="reg in receipt.regs" :key="reg.id" :label="reg.opNo" size="mini">
        <el-popover placement="top-start" :title="reg.date" trigger="hover">
          <span>{{ reg.deptCode | dictText("Dept") }}：{{ reg.regType | dictText("RegType") }}</span>
          <span slot="reference">{{ reg.opNo }}</span>
        </el-popover>
      </el-checkbox>
    </el-checkbox-group>
    <el-main style="padding: 0 2.5rem 0 2.5rem">
      <el-collapse v-loading="meta.searching" style="height:30rem;">
        <el-alert v-if="!patient" :closable="false" center style="background:white;">请选择患者！</el-alert>
        <el-alert v-if="patient && (!receipt.regs || !receipt.regs.length) && !meta.searching" :closable="false" center style="background:white;">患者没有需要收费的单据！</el-alert>
        <el-collapse-item v-if="drugRps.length" name="药品" title="西成药处方">
          <div slot="title" style="display:flex;justify-content:space-between;align-items:center;width:100%">
            <b>西药 / 中成药处方：</b>
            <el-tag type="info" class="right-pad no-border" effect="plain" style="float:right">
              处方数：<span style="color:#409eff">{{ countSelected(drugRps) }}</span> / {{ drugRps.length }} ， 金额：<span class="red">{{ amountSelected(drugRps) | fmtFloat(2) }}</span> / <span>{{ amount(drugRps) | fmtFloat(2) }}</span>
            </el-tag>
          </div>
          <rp-card v-for="rp in drugRps" :key="rp.id" :rp="rp" :details="receipt.drugDetails.filter((d) => d.rpNo == rp.no)" @mlSelectChange="mlSelectChange"></rp-card>
        </el-collapse-item>
        <el-collapse-item v-if="herbalRps.length" name="草药" title="草药处方">
          <div slot="title" style="display:flex;justify-content:space-between;align-items:center;width:100%">
            <b>中草药处方：</b>
            <el-tag type="info" class="right-pad no-border" effect="plain" style="float:right">
              处方数：<span style="color:#409eff">{{ countSelected(herbalRps) }}</span> / {{ herbalRps.length }} ， 金额：<span class="red">{{ amountSelected(herbalRps) | fmtFloat(2) }}</span> / <span>{{ amount(herbalRps) | fmtFloat(2) }}</span>
            </el-tag>
          </div>
          <rp-card v-for="rp in herbalRps" :key="rp.id" :rp="rp" :details="receipt.herbalDetails.filter((d) => d.rpNo == rp.no)" @mlSelectChange="mlSelectChange"></rp-card>
        </el-collapse-item>
        <el-collapse-item v-if="mlApps.length" name="检验" title="检验申请单">
          <div slot="title" style="display:flex;justify-content:space-between;align-items:center;width:100%">
            <b>检验申请单：</b>
            <el-tag type="info" class="right-pad no-border" effect="plain" style="float:right">
              申请数：<span style="color:#409eff">{{ countSelected(mlApps) }}</span> / {{ mlApps.length }} ， 金额：<span class="red">{{ amountSelected(mlApps) | fmtFloat(2) }}</span> / <span>{{ amount(mlApps) | fmtFloat(2) }}</span>
            </el-tag>
          </div>
          <ml-card v-for="app in mlApps" :key="app.id" :ml="app" :details="receipt.mlDetails.filter((d) => d.appNo == app.no)" @mlSelectChange="mlSelectChange" />
        </el-collapse-item>
        <el-collapse-item v-if="miApps.length" name="检查" title="检查申请单">
          <div slot="title" style="display:flex;justify-content:space-between;align-items:center;width:100%">
            <b :style="`color: ${(JSON.stringify(separateSettle) != '{}' && countSelected(miApps) > 0) ? '#e6a23c' : 'black'}`">检查申请单：</b>
            <el-tag type="info" class="right-pad no-border" effect="plain" style="float:right">
              申请数：<span style="color:#409eff">{{ countSelected(miApps) }}</span> / {{ miApps.length }} ， 金额：<span class="red">{{ amountSelected(miApps) | fmtFloat(2) }}</span> / <span>{{ amount(miApps) | fmtFloat(2) }}</span>
            </el-tag>
          </div>
          <ml-card v-for="app in miApps" :key="app.id" :ml="app" :details="receipt.miDetails.filter((d) => d.appNo == app.no)" :borderColor="(separateSettle[app.no] && filterSelected(miApps).find(v => v.id == app.id)) ? '#e6a23c' : '#ebeef5'" @mlSelectChange="mlSelectChange" />
        </el-collapse-item>
        <el-collapse-item v-if="therapyApps.length" name="治疗" title="治疗申请单">
          <div slot="title" style="display:flex;justify-content:space-between;align-items:center;width:100%">
            <b>治疗申请单：</b>
            <el-tag type="info" class="right-pad no-border" effect="plain" style="float:right">
              申请数：<span style="color:#409eff">{{ countSelected(therapyApps) }}</span> / {{ therapyApps.length }} ， 金额：<span class="red">{{ amountSelected(therapyApps) | fmtFloat(2) }}</span> / <span>{{ amount(therapyApps) | fmtFloat(2) }}</span>
            </el-tag>
          </div>
          <therapy-card v-for="app in therapyApps" :key="app.id" :rp="app" :details="receipt.therapyDetails.filter((d) => d.appNo == app.no)" @mlSelectChange="mlSelectChange"></therapy-card>
        </el-collapse-item>
      </el-collapse>
    </el-main>

    <el-row type="flex" justify="end" align="middle" slot="footer">
      <el-col class="left" v-if="entity.patientId" :span="4">
        <span>发票号：{{ entity.invoiceNo }}</span>
      </el-col>
      <el-col :span="20">
        <el-button v-if="patient" type="text" @click="refresh" icon="el-icon-refresh" class="left-pad"></el-button>
        <el-tag v-if="patient" type="info" class="no-border left-pad" effect="plain" size="middle">
          <span>单据数：</span>
          <strong style="color:red">{{ sumSelected }}</strong> / <span>{{ sum }}</span>
          <span class="left-pad">金额合计：</span>
          <strong style="color:red">{{ sumAmountSelected | fmtFloat(2) }}</strong> / <span>{{ sumAmount | fmtFloat(2) }}</span>
        </el-tag>
        <el-button type="primary" v-if="sumAmountSelected > 0 && showBtnBySeparateSettle" @click="openPay" class="left-pad">支 付</el-button>
        <el-button type="default" v-if="!entity.patientId" @click="close">关 闭</el-button>
      </el-col>
    </el-row>
    <!-- <pay-dialog :reg="currentReg" :rps="selectedRps" :visible.sync="meta.showPay" @paid="paid"></pay-dialog> -->
    <pay-dialog :opType="opType" :feeReceipt="receiptForPay" :visible.sync="meta.showPay" @paid="paid" @cancel="cancelPay" :freeItem="Object.keys(separateSettle).length > 0"></pay-dialog>
  </el-dialog>
</template>

<script>
  import api from "./api";
  import { mapGetters } from "vuex";
  import print from "@/common/print.js";
  export default {
    components: {
      "rp-card": () => import("./_rp"),
      "therapy-card": () => import("./_therapy"),
      "ml-card": () => import("./_ml"),
      "patient-selector": () => import("@/components/_com/selectorPatient"),
      "pay-dialog": () => import("./pay"),
    },
    props: {
      visible: { type: Boolean, default: false },
      entity: { type: Object, default: () => {} },
      // 来自列表的身份证信息
      idCard: { type: Object, default: null }
    },
    data() {
      return {
        patient: null,
        receipt: {},
        regs: [],
        receiptForPay: {},
        opType: "自费",
        payInfo: null,
        meta: {
          showPay: false,
          searching: false,
          tabLoading: false,
        },
        separateSettle: {}, // 单独结算标志
        showBtnBySeparateSettle: true
      };
    },
    computed: {
      ...mapGetters(["Enum", "user", "dict"]),
      sum() {
        return this.drugRps.length + this.herbalRps.length + this.mlApps.length + this.miApps.length + this.therapyApps.length;
      },
      sumSelected() {
        return this.countSelected(this.drugRps) + this.countSelected(this.herbalRps) + this.countSelected(this.mlApps) + this.countSelected(this.miApps) + this.countSelected(this.therapyApps);
      },
      sumAmount() {
        return this.amount(this.drugRps) + this.amount(this.herbalRps) + this.amount(this.mlApps) + this.amount(this.miApps) + this.amount(this.therapyApps);
      },
      sumAmountSelected() {
        return this.amountSelected(this.drugRps) + this.amountSelected(this.herbalRps) + this.amountSelected(this.mlApps) + this.amountSelected(this.miApps) + this.amountSelected(this.therapyApps);
      },
      receiptAmount() {
        return 0;
      },
      drugRps() {
        return this.filterByRegSelected(this?.receipt?.drugRps);
      },
      herbalRps() {
        return this.filterByRegSelected(this?.receipt?.herbalRps);
      },
      mlApps() {
        return this.filterByRegSelected(this?.receipt?.mlApps);
      },
      miApps() {
        return this.filterByRegSelected(this?.receipt?.miApps);
      },
      therapyApps() {
        return this.filterByRegSelected(this?.receipt?.therapyApps);
      },
      mlGrps() {
        let grps = [];
        this.regMls.forEach((rp) => {
          if (rp.groupNo && grps.findIndex((g) => g.no == rp.groupNo) == -1) {
            grps.push({ no: rp.groupNo, selected: true });
          }
        });
        return grps;
      },
      selectedRps() {
        return this.regRps.filter((rp) => rp.selected);
      },
    },
    watch: {
      idCard(val) {
        this.$nextTick(() => {
          if (val && this.$refs.refPatient) {
            // 在列表页面点击“身份证读卡”后，直接调用
            this.$refs.refPatient.query(this.idCard, false);
          }
        });
      }
    },
    methods: {
      checkboxChange(v) {
        if (v.length > 0) {
          this.setSeparateSettle()
        }
      },
      mlSelectChange({ selected, no }) {
        const drugRps = this.filterSelected(this.drugRps)
        const herbalRps = this.filterSelected(this.herbalRps)
        const mlApps = this.filterSelected(this.mlApps)
        const therapyApps = this.filterSelected(this.therapyApps)
        if (!selected) {
          delete this.separateSettle[no]
        } else {
          this.receipt.miDetails.forEach(v => {
            if (v.appNo == no && ['V-01', 'V-02', 'P-01', 'P-02', 'D-01', 'SXTC'].find(code => code == v.code)) {
              this.$set(this.separateSettle, no, true)
            }
          })
        }
        let len = Object.keys(this.separateSettle).length
        let miApps = this.filterSelected(this.miApps)
        // 勾选的项目只有预设项目 || 没有预设项目
        if ((len == miApps.length && drugRps.length == 0 && herbalRps.length == 0 && mlApps.length == 0 && therapyApps.length == 0) || len == 0) {
          this.showBtnBySeparateSettle = true
        } else {
          this.showBtnBySeparateSettle = false
        }
      },
      init() {
        this.patient = null;
        this.receipt = {};
        this.regs = [];
      },
      refresh() {
        this.regs = [];
        this.receipt = {};
        this.query();
      },
      filterByRegSelected(items) {
        return (items || []).filter((rp) => this.regs.findIndex((no) => no == rp.opNo) >= 0);
      },
      filterSelected(items) {
        return (items || []).filter((it) => it.selected);
      },
      count(items) {
        return items.length;
      },
      countSelected(items) {
        return this.filterSelected(items).length;
      },
      amount(items) {
        return items.reduce((a, b) => a + b.price, 0);
        // return items.reduce((a, b) => a + (b.price * (b.quantity || 1)), 0)
      },
      amountSelected(items) {
        return this.filterSelected(items).reduce((a, b) => a + (b.price || 0), 0);
      },
      openPay() {
        this.receiptForPay = {
          regs: this.filterByRegSelected(this.receipt.regs),
          drugRps: this.filterSelected(this.drugRps),
          herbalRps: this.filterSelected(this.herbalRps),
          miApps: this.filterSelected(this.miApps),
          mlApps: this.filterSelected(this.mlApps),
          therapyApps: this.filterSelected(this.therapyApps),
          enterprise: this.patient.enterprise
        };
        this.meta.showPay = true;
      },
      setSeparateSettle() {
        const drugRps = this.filterSelected(this.drugRps)
        const herbalRps = this.filterSelected(this.herbalRps)
        const mlApps = this.filterSelected(this.mlApps)
        const therapyApps = this.filterSelected(this.therapyApps)
        this.receipt.miDetails.forEach(v => {
          if (['V-01', 'V-02', 'P-01', 'P-02', 'D-01', 'SXTC'].find(_ => _ == v.code)) {
            this.$set(this.separateSettle, v.appNo, true)
          }
        })
        let len = Object.keys(this.separateSettle).length
        // 勾选的项目只有预设项目 || 没有预设项目
        if ((len == this.miApps.length && drugRps.length == 0 && herbalRps.length == 0 && mlApps.length == 0 && therapyApps.length == 0) || len == 0) {
          this.showBtnBySeparateSettle = true
        } else {
          this.showBtnBySeparateSettle = false
        }
        if (len > 0 && len != this.miApps.length) {
          this.$message({
            type: 'warning',
            message: '该结算存在免费舌象项目，请单独结算！',
            showClose: true,
            duration: 5000
          })
        }
      },
      query() {
        this.meta.searching = true;
        this.$set(this, "separateSettle", {})
        api
          .chgQueryPending(this.patient.id)
          .then((res) => {
            this.receipt = res;
            this.regs.push(...this.receipt.regs.map((r) => r.opNo));
            this.setSeparateSettle()
          })
          .catch((err) => {
            if (err) {
              this.$message.error(err.message || err);
            }
          })
          .finally(() => {
            this.meta.searching = false;
          });
      },
      close() {
        this.$emit("update:visible", false);
      },
      paid(payInfo) {
        // 加try finally是防止没有打印插件时，不执行 refresh
        try {
          this.chargeVoucher(JSON.parse(JSON.stringify(payInfo)));
        } finally {
          this.refresh();
          this.$emit("paid");
        }
      },
      // R202208，收费后执行自动打印
      chargeVoucher(payInfo) {
        const template = this.dict.PrintTemplate.find((t) => t.code === "ChargeReceipt");
        if (!template) {
          this.$message.error("未配置打印模板！");
          return;
        }
        let selectedNo = []; // 已勾选的中医/西医处方号、检查单、检验单
        const {
          drugDetails, herbalRps, herbalDetails, mlDetails, miDetails, therapyDetails, regs
        } = this.receipt;
        selectedNo = [
          ...this.receiptForPay.drugRps.map(item => { return item.no; }),
          ...this.receiptForPay.herbalRps.map(item => { return item.no; }),
          ...this.receiptForPay.miApps.map(item => { return item.no; }),
          ...this.receiptForPay.mlApps.map(item => { return item.no; }),
          ...this.receiptForPay.therapyApps.map(item => { return item.no; })
        ]
        // console.log('打印参数selectedNo==', selectedNo);
        // step2: 在中医/西医处方、申请单 详情里过滤得到已勾选的 处方号、单号
        const drugItem = drugDetails.filter((d) => selectedNo.includes(d.rpNo));
        const herbalItem = herbalDetails.filter((d) => selectedNo.includes(d.rpNo));
        const mlItem = mlDetails.filter((d) => selectedNo.includes(d.appNo));
        const miItem = miDetails.filter((d) => selectedNo.includes(d.appNo));
        const therapyItem = therapyDetails.filter((d) => selectedNo.includes(d.appNo));
        // console.log(payInfo, '费用明细', [...drugItem, ...herbalItem, ...mlItem, ...miItem]);
        // console.log(this.receipt, 3300, drugItem, herbalItem, mlItem, miItem, therapyItem);
        if (herbalItem.length > 0) {
          // 中药处方，有剂量。剂量要从herbalRps里获取
          herbalItem.forEach((h) => {
            h.rpQuantity = herbalRps.find((i) => i.no === h.rpNo)?.quantity || 1;
          });
        }

        const {
          patientName, opType, no, payWay, feeAmount, feeCash, feeFund, operatorUserId, feeDiscount
        } = payInfo;
        const { fmtFloat, dictText } = this.$utils;
        function formatFloat(val) {
          return fmtFloat(val, 2);
        }
        const items = [...drugItem, ...herbalItem, ...mlItem, ...miItem, ...therapyItem];
        const patientInfo = regs ? regs[0] : null;
        let cardNo = ''
        if (patientInfo) {
          cardNo = patientInfo.cardNo
        }
        const data = {
          patientName, // 姓名
          cardNo,
          opType, // 患者费别
          no,
          paymentType: dictText(payWay, "PayWay"),// 支付方式
          amount: formatFloat(feeAmount), // 费用合计
          insurance: formatFloat(0), // 医保内，新接口的数据里已经没有insurance字段，暂时显示为0。this.$utils.fmtFloat(this.entity.insurance, 2),
          accountPayments: formatFloat(feeFund), // 基金支付
          payment: formatFloat(feeCash), // 个人支付
          items,
          operatorUserId, // 收费员
          opNo: items[0].opNo, // 门诊号
          // reg: this.isRegCharge ? this.reg : null,
          // hospitalName: this.user.tenantName + "收费凭条",
        };
        console.log('打印参数==', data);
        print.chargeReceipt(data, template.content);
      },
      cancelPay() {},
    },
  };
</script>
